// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__31ySo","col":"CardReaderDesc_col__2UB96","label":"CardReaderDesc_label__KNJ5b"};